import {
  getOrderList,
  tripOrderDetail,
  exportInvoice
} from '../services';

export default {
  namespace: 'tripOrder',
  state: {

  },
  effects: {
    // 获取订单列表
    * getOrderList ({ payload }, { call }) {
      const result = yield call(getOrderList, payload);
      return result;
    },
    * tripOrderDetail ({ payload }, { call }) {
      const result = yield call(tripOrderDetail, payload);
      return result;
    },
    * exportInvoice ({ payload }, { call }) {
      const result = yield call(exportInvoice, payload);
      return result;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
